import ARC_LOGO from "../images/ARC_LOGO.png";
import AMD_LOGO from "../images/AMD_LOGO.webp";
import PECS_LOGO from "../images/PECS_LOGO.webp";
import INTERNSHALA_LOGO from "../images/INTERNSHALA_LOGO.webp";
import coffeeSales from "../images/coffeeSales.png";
import breakingBarriers from "../images/breakingBarriers.jpg";
import covidApp from "../images/covidApp.jpeg";
import coswara from "../images/coswara.jpg";
import candianCO2 from "../images/candianCO2.jpg";
import medallionArch from "../images/medallionArch.webp";
import competitveAnalysis from "../images/competitveAnalysis.png";
import creditCard from "../images/creditCard.jpeg";
import BankChurnAnalysis from "../images/BankChurnAnalysis.png";
import finanseerMERN from "../images/finanseerMERN.jpeg";
import cryptoWhiz from "../images/cryptoWhiz.jpeg";
import guitarJam1 from "../videos/guitarJam1.mp4";
import appliedResearchDay from "../images/appliedResearchDay.jpeg";
import ARD from "../images/ARD.JPG";
import Presenting from "../images/Presenting.JPG";
import RecTeam from "../images/RecTeam.JPG";
import snowboarding_1 from "../images/Snowboarding1.JPG";
import snowboarding_2 from "../images/Snowboarding2.JPG";
import snowboarding_3 from "../images/Snowboarding3.JPG";
import teamSAA from "../images/teamSAA.jpeg";

export const Bio = {
  name: "Manraj Singh",
  roles: ["Data Analyst", "Guitarist"],
  description:
    "Welcome to my e-portfolio, and thank you for taking the time to look at my work. This space serves as a snapshot of my career journey, showcasing the technical skills I’ve honed, the projects I’ve delivered, and the professional experiences that have shaped my approach to problem-solving. Creating it has been a deeply personal endeavor, reflecting the hours I’ve spent learning, growing, and refining my craft. Each project here represents a piece of my story; a testament to my passion for turning challenges into opportunities. If my skills journey resonates with you, I invite you to explore further, connect with me, and consider how we might work together in the future. Thank you again for visiting, and I hope you find something here that sparks inspiration.",
  github: "https://github.com/therealmanraj",
  resume:
    "https://drive.google.com/file/d/1rt42ZLWdk1crN8d9oINuAVvdtrLNZ1f_/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/therealmanraj/",
  twitter: "https://twitter.com/imtherealmanraj",
};

export const skills = [
  {
    title: "Data Analysis",
    skills: [
      {
        name: "Python",
        image: "https://www.vectorlogo.zone/logos/python/python-icon.svg",
      },
      {
        name: "MySQL",
        image: "https://www.vectorlogo.zone/logos/mysql/mysql-icon.svg",
      },
      {
        name: "Power BI",
        image:
          "https://www.vectorlogo.zone/logos/microsoft_powerbi/microsoft_powerbi-icon.svg",
      },
      {
        name: "Tableau",
        image: "https://cdn.worldvectorlogo.com/logos/tableau-software.svg",
      },
      {
        name: "Microsoft Office",
        image: "https://cdn.worldvectorlogo.com/logos/office-1.svg",
      },
    ],
  },
  {
    title: "Web Development",
    skills: [
      {
        name: "React JS",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Material UI",
        image: "https://cdn.worldvectorlogo.com/logos/material-ui-1.svg",
      },
      {
        name: "Node JS",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express JS",
        image: "https://www.vectorlogo.zone/logos/expressjs/expressjs-icon.svg",
      },
    ],
  },
  {
    title: "Tools",
    skills: [
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Canva",
        image:
          "https://yt3.googleusercontent.com/M7S2_gnnaJT5buAfWW4tanX9NELz5PddzNCQgnRV1oP8t12s5pg4cYKMChkEoh8gtGX__KtcYKU=s900-c-k-c0x00ffffff-no-rj",
      },
    ],
  },
  {
    title: "Soft Skills",
    skills: [
      {
        name: "Adaptability",
        image: "https://cdn-icons-png.flaticon.com/512/10108/10108220.png",
      },
      {
        name: "Communication",
        image:
          "https://img.icons8.com/?size=100&id=54385&format=png&color=FFFFFF",
      },
      {
        name: "Teamwork",
        image: "https://cdn-icons-png.flaticon.com/512/7086/7086327.png",
      },
      {
        name: "Problem-Solving",
        image:
          "https://cdn-icons-png.freepik.com/256/8553/8553558.png?semt=ais_hybrid",
      },
      {
        name: "Time Management",
        image: "https://cdn-icons-png.flaticon.com/512/9815/9815843.png",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: ARC_LOGO,
    role: "Research Assistant",
    company: "Applied Research Centre",
    date: "September 2024 - Current",
    desc: "Optimized data pipelines to predict HVAC usage and maintenance needs, achieving a 9% reduction in energy consumption. Engineered sustainable solutions for campus projects, boosting efficiency by 15%.",
    skills: [
      "Python",
      "SQL",
      "React JS",
      "Node JS",
      "Poster Making",
      "Reporting",
      "Data Analysis",
    ],
  },
  {
    id: 1,
    img: AMD_LOGO,
    role: "Data Analyst Co-Op",
    company: "AMD",
    date: "June 2022 - June 2023",
    desc: "Developed interactive dashboards to streamline cross-team collaboration, cutting manual reporting by 15 hours/week. Integrated advanced analytics in Power BI to provide real-time insights for executive decisions.",
    skills: [
      "Python",
      "SQL",
      "React JS",
      "Node JS",
      "Power BI",
      "Microsoft Excel",
      "Flask",
    ],
  },
  {
    id: 2,
    img: PECS_LOGO,
    role: "AI Project Intern",
    company: "PECS",
    date: "May 2022 - July 2022",
    desc: "Built UI/UX of the website with a metaverse theme. Was also tasked with cleaning the existing university data.",
    skills: ["Figma", "SQL", "Python"],
  },
  {
    id: 3,
    img: INTERNSHALA_LOGO,
    role: "Internshala Student Partner 27",
    company: "Internshala",
    date: "Febuary 2022 - April 2022",
    desc: "Promoted the Internshala brand, products, and services among my peers, and hosted activities like online seminars and built relationships with students and faculty.",
    skills: ["Marketing", "Commpuncation", "Presentation", "Leadership"],
  },
];

export const education = [
  {
    id: 0,
    img: "https://ogsl.ca/commons/projet/ckan/logo/langara.png",
    school: "Langara College",
    date: "May 2024 - Present",
    grade: "3.83 GPA",
    desc: "Data Analytics is an area containing the relevant tools that allow you to divide and conquer massive data sets so as to find the needle for the right fabric.",
    degree: "Post Graduate Diploma in Data Analysis",
  },
  {
    id: 1,
    img: "https://www.amity.edu/images/amity_logo.png",
    school: "Amity University, Noida",
    date: "July 2019 - June 2023",
    grade: "7.59 CGPA",
    desc: "As a B.Tech graduate from Amity University, Noida, I've emerged with a strong foundation in Computer Science. My journey at this prestigious institution has shaped me into a tech enthusiast with a passion for innovation.",
    degree: "Bachelor of Technology - B.Tech, Computer Science and Engineering",
  },
  {
    id: 2,
    img: "https://www.vrmvk.org/sites/default/files/gva-sliderlayer-upload/vkvlogo1_small_shadow-wpbjfc.png",
    school: "Vivekananda Kendra Vidyalaya, Dibrugarh",
    date: "Apr 2017 - Apr 2019",
    grade: "85.6%",
    desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
    degree: "ISC(XII), Science with Computer",
  },
  {
    id: 3,
    img: "data:image/jpeg;base64,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",
    school: "Don Bosco School, Dibrugarh",
    date: "Apr 2017 - Apr 2019",
    grade: "92.3%",
    desc: "I completed my class 10 education at Methodist School, Dankuni, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
  },
];

export const projects = [
  {
    id: 0,
    title: "Bank of Europe Churn Analysis",
    description:
      "Led an impactful project within the banking sector, orchestrating data-driven strategies to reduce customer churn across three countries: France, Germany, and Spain. By segmenting customers, age profiling, and personalized communication, we tailored retention plans. We addressed country-specific issues, with a focus on Germany, and targeted high-churn age groups like 35-40. The project emphasized feedback integration, employee training, and predictive analytics for proactive churn management.",
    image: BankChurnAnalysis,
    tags: ["Tableau", "Data Analysis", "Churn Analysis"],
    category: "data analysis",
    webapp:
      "https://public.tableau.com/app/profile/manraj.singh4264/viz/BankChurnAnalysis_16983365275080/Dashboard1",
  },
  {
    id: 1,
    title: "Coffee Sales Dashboard",
    description:
      "The Coffee Sales Dashboard is an Excel project that provides visualized insights into coffee sales data. The dashboard features a dynamic line chart displaying the total sales of various coffee roast types over time. Additionally, it includes a bar chart to showcase the top 5 customers and another bar chart to illustrate sales by country. Users can customize their analysis through interactive elements, including a timeline selector for choosing specific date ranges, a roast type selector to compare different coffee varieties, and size and loyalty selectors for tailored filtering. Key Excel features used in the project include charts, data validation, pivot tables, slicers, named ranges, and conditional formatting to enhance data presentation and user interactivity.",
    image: coffeeSales,
    tags: ["Excel", "Pivot Tables", "Advance Excel Functions"],
    category: "data analysis",
    webapp:
      "https://onedrive.live.com/edit?id=D8EC99F49B18BD6B!4383&resid=D8EC99F49B18BD6B!4383&ithint=file%2cxlsx&authkey=!AJFXaFQ-yHoamLM&wdo=2",
  },
  {
    id: 2,
    title: "COSWARA Audio Analysis and Classification Model",
    description:
      "EDA and statistical tests showed significant variations in audio features across age, gender, and health status. Automated data preprocessing and feature extraction, improving the efficiency and accuracy of the analysis. Engineered a model to classify COVID-19 status from mel spectrograms, achieving 81.54% accuracy.",
    image: coswara,
    tags: ["Python", "Data Visualization", "EDA", "CNN"],
    category: "data science",
    github: "https://github.com/therealmanraj/coswara",
  },
  {
    id: 3,
    title: "Canada Vehicle CO2 Emission EDA and Prediction Model",
    description:
      "Built a regression model to predict CO2 emissions from vehicles in Canada. Analysed key emission factors, identifying fuel type & transmission type as major contributors. Achieved an R-squared value of 0.9985 and an RMSE of 2.47, simplifying predictors and identifying key interactions that led to a more credible and effective model.",
    image: candianCO2,
    tags: ["Python", "Data Visualization", "EDA", "ML"],
    category: "data science",
    github: "https://github.com/therealmanraj/carbonEmissions",
  },
  {
    id: 4,
    title: "Breaking Barriers: Predicting Student Success",
    description:
      "Inspired by students, I studied how factors like gender, ethnicity, and parental education affect exam scores. Built CI/CD ML pipeline to clean data, engineer features, and train models for predicting student scores. Deployed the model using Azure with an R² score of 0.8522, explaining 85.22% variance in predictions.",
    image: breakingBarriers,
    tags: ["Python", "Data Visualization", "ML Pipeline"],
    category: "data science",
    github:
      "https://github.com/therealmanraj/students-Performance-ML-E2E-Project",
  },
  {
    id: 5,
    title: "Medallion Architecture Azure Pipeline",
    description:
      "Developed a scalable ETL pipeline using Data Factory, Databricks, and Synapse with Medallion Architecture. Automated data ingestion and transformation, ensuring data readiness for creating dashboards in Power BI via Azure Synapse Analytics SQL connector.",
    image: medallionArch,
    tags: ["Python", "Azure Cloud"],
    category: "data analysis",
    github:
      "https://github.com/therealmanraj/Adventure-Works-Data-Engineering-Project",
  },
  {
    id: 6,
    title: "Financial Credit Card Approval EDA and ML Pipeline",
    description:
      "Performed EDA on credit card transaction data, identifying fraudulent patterns and anomalies. Developed an ML pipeline for credit approval prediction, with feature selection and model training. Achieved 90% recall, identifying income and relationship status as primary approval decision factors.",
    image: creditCard,
    tags: ["Python", "Data Visualization", "EDA", "ML"],
    category: "data science",
    github: "https://github.com/therealmanraj/Credit-Card-Approval-Prediction",
  },
  {
    id: 7,
    title: "Competitive Intelligence",
    description:
      "A competitor analysis on Google Play apps to highlight rating drivers and strategic positioning. Found lightweight, paid apps achieve highest ratings; app size and pricing heavily influence success. Health & Fitness apps exceeding 85% positive reviews, while free apps face harsher scrutiny.",
    image: competitveAnalysis,
    tags: ["Python", "Data Visualization", "EDA"],
    category: "data analysis",
    github: "https://github.com/therealmanraj/Google-Play-Store-Apps-Analysis",
  },
  // {
  //   id: 3,
  //   title:
  //     "Building an automated model to predict and detect early onset osteoarthritis.",
  //   date: "January 2023 - June 2023",
  //   description:
  //     "This research targets the need to provide early detection of osteoarthritis to assist the ongoing global effort to make treatment of this disease viable and effective. With regards to the rapid degradation of the condition, it is critical to detect it early enough so that suppressive treatment can reduce symptoms and progression. Using an approach of automation via efficient data analysis, it is possible to detect arthritis quite early in a patient’s diagnostics. This paper aims to provide both a statistical and a more direct approach to the determination of the probability of osteoarthritis at early onset to improve the odds for a patient. The system will take primary variables from a patient's file and look for patterns matching cases in the dataset it was trained against. The dataset for the same has been taken from the NIH archive for academic purposes.",
  //   image: arthResearchPaper,
  //   tags: ["Python", "Machine Learning", "Pandas", "SciKit Learn"],
  //   category: "research paper",
  //   github: "https://github.com/therealmanraj/arthDetector",
  //   paper: "https://ieeexplore.ieee.org/document/10262572",
  // },
  {
    id: 8,
    title: "Finanseer",
    // date: "September 2023 - November 2023",
    description:
      "A cutting-edge MERN stack financial dashboard with machine learning predictions. Powered by Vite, Redux Toolkit, and Material UI for the frontend, and Node.js, Express.js, and MongoDB for the backend, Finanseer offers dynamic financial charts and real-time data updates. It currently uses dummy data to demonstrate its potential for handling real financial data. As both a software developer and data analyst, I'm excited to bridge the gap between these roles. Whether you're an experienced investor or new to finance, our user-friendly Material UI design ensures a seamless experience. ",
    image: finanseerMERN,
    tags: ["MERN", "Machine Learning", "CI/CD"],
    category: "web app",
    github: "https://github.com/therealmanraj/finanseer",
    webapp: "https://neon-biscotti-086dd3.netlify.app/",
  },
  {
    id: 9,
    title: "CryptoWhiz",
    // date: "September 2023 - October 2023",
    description:
      "Introducing CryptWhiz! I'm thrilled to share my React app, CryptWhiz. While it may not be flawless, it's a testament to my skills in data visualization, APIs, and web development. CryptWhiz empowers users to track and visualize real-time cryptocurrency data. With API integration and interactive charts, it offers a user-friendly experience. ",
    image: cryptoWhiz,
    tags: ["React", "Rapid API"],
    category: "web app",
    github: "https://github.com/therealmanraj/cryptwhiz",
    webapp: "https://lucent-sorbet-9e60d1.netlify.app/",
  },
  {
    id: 10,
    title: "COVID Application",
    // date: "August 2021 - September 2021",
    description:
      "The COVID-19 App, developed with Android Studio, is a versatile application that serves as a one-stop resource for COVID-19 information. It provides real-time data tracking, including cases and trends globally and locally. Users can access comprehensive vaccination information, including eligibility and appointment scheduling. The app offers essential COVID-19 guidelines and official resources for safety and testing. To facilitate navigation, it integrates Google Maps, helping users find testing centers and vaccination sites. With its user-friendly interface, the app ensures that users have quick and easy access to accurate and critical information, making it an invaluable tool in navigating the pandemic.",
    image: covidApp,
    tags: ["Java", "XML", "Android Studio", "Google API"],
    category: "web app",
    github: "https://github.com/therealmanraj/COVID",
  },
];

export const pictures = [
  {
    id: 0,
    title: "Applied Research Day",
    type: "image",
    images: [Presenting, appliedResearchDay, RecTeam, ARD],
    description:
      "I presented my work on building 'SQL Beyond,' a gamified SQL learning platform. I also collaborated with the Langara Recreation department to design promotional posters—an amazing blend of data, creativity, and campus engagement!",
  },
  {
    id: 1,
    title: "Langara Alumni and Student networking",
    type: "image",
    image:
      "https://media.licdn.com/dms/image/v2/D5622AQGnRD_Om36QKQ/feedshare-shrink_2048_1536/B56ZW3AlaAGsAo-/0/1742532139330?e=1745452800&v=beta&t=gGISwWezQ5WqBy5NpTNgoWauJAjQ01p1B_mdKHtdSdo",
    description:
      "Attended a fantastic alumni meet where I connected with incredible people—exchanging stories, experiences, and forging new friendships along the way.",
  },
  {
    id: 2,
    title: "Langara Makerspace Team",
    type: "image",
    images: [
      "https://media.licdn.com/dms/image/v2/D5622AQFiSlo3rL0Cfg/feedshare-shrink_2048_1536/B56ZV9cj9uHsAo-/0/1741566405534?e=1745452800&v=beta&t=jfEt66N9V55thIfwtK36MbAk53yEZsL2aotETxQJ-n8",
      "https://media.licdn.com/dms/image/v2/D5622AQGx1cjNsfoBKA/feedshare-shrink_2048_1536/B56ZV9cj9jHsAo-/0/1741566398825?e=1745452800&v=beta&t=C2ZnMEdcPYY81xXiAlhdmIjtaQouPoN2dFUuEDmasqk",
      "https://media.licdn.com/dms/image/v2/D5622AQFYm0UzA0KR_Q/feedshare-shrink_2048_1536/B56ZV9cj_FGsAo-/0/1741566406566?e=1745452800&v=beta&t=qnPa1OozorXoE1ogPmAolJwFSPXxaiKCsCZsTH8HMu8",
      "https://media.licdn.com/dms/image/v2/D5622AQHCsaDK5UKWRQ/feedshare-shrink_1280/B56ZV9cj9qGUAk-/0/1741566405935?e=1745452800&v=beta&t=Dgyj924OJAzb9eDQcTYxZTcHVqSogU7DcrYMQ7CcrA4",
      "https://media.licdn.com/dms/image/v2/D5622AQFakwA8iPh-xw/feedshare-shrink_2048_1536/B56ZV9ckASGQAs-/0/1741566406682?e=1745452800&v=beta&t=vUCYRqvt_OFv2qJXaTJrnA-eu9_VcMQ0yWE5Nl4LJ_4",
      "https://media.licdn.com/dms/image/v2/D5622AQEdVnoI0SvX3Q/feedshare-shrink_2048_1536/B56ZV9cj9uGQAo-/0/1741566402497?e=1745452800&v=beta&t=KONEA8sRpbCmq7yiqiyeCYFuSErHQ3fWGqao30REc0Y",
    ],
    description:
      "As a Research Assistant, I helped build a reusable plastic heat press machine for the Vancouver maker space. This project fused sustainability, hands-on engineering, and creative problem-solving—a truly rewarding experience.",
  },
  {
    id: 4,
    title: "Grouse Mountain",
    type: "image",
    images: [snowboarding_1, snowboarding_2, snowboarding_3],
    description:
      "I went on a breathtaking snowboarding trip to Grouse Mountain—fresh powder, stunning views, and an unforgettable adventure on the slopes!",
  },
  {
    id: 5,
    title: "Guitar Jam",
    type: "video",
    video: guitarJam1,
    description:
      "I play guitar, and this jam in A minor is one of my favorites. Music has always been a passion—there’s nothing like the thrill of improvising a fresh riff!",
  },
  {
    id: 6,
    title: "Team SAA",
    type: "image",
    image: teamSAA,
    description:
      "My incredible AMD Team SAA—the Indian team—where I worked as a Data Analyst Co-Op. I made lifelong friends here, and our camaraderie remains strong!",
  },
];
